"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var react_router_dom_1 = require("react-router-dom");
var journey_services_1 = require("@athena-portal/journey-services");
var LinkWidget = /** @class */ (function (_super) {
    __extends(LinkWidget, _super);
    function LinkWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.onClick = function () {
            var _a;
            var interaction = _this.props.interaction;
            var madeChanges = (_a = interaction.uistate.changes) !== null && _a !== void 0 ? _a : [];
            var shouldPush = interaction.jointPolicyHolder != null;
            if (shouldPush) {
                if (!madeChanges.includes(_this.changeField)) {
                    madeChanges.push(_this.changeField);
                }
            }
            else {
                madeChanges = madeChanges.filter(function (e) { return e !== _this.changeField; });
            }
            _this.updates.forEach(function (_a) {
                var field = _a.field, value = _a.value;
                journey_services_1.ObjectManipulator.setField(field, interaction, value);
            });
            journey_services_1.ObjectManipulator.setField("uistate.interactionChangesDetected", interaction, true);
            _this.props.onStateChange("uistate.changes", madeChanges);
        };
        _this.cssClass = _this.getSetting("cssClass", "");
        _this.ariaLabel = _this.getSetting("ariaLabel", "");
        _this.onClick = _this.onClick.bind(_this);
        _this.updates = _this.getSetting("updates", []);
        _this.changeField = _this.getSetting("changeField");
        return _this;
    }
    LinkWidget.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { type: "button", className: this.cssClass, "aria-label": this.ariaLabel, onClick: this.onClick, to: "#", children: this.props.question.label }));
    };
    return LinkWidget;
}(plugin_journey_1.WidgetBase));
exports.LinkWidget = LinkWidget;
//# sourceMappingURL=LinkWidget.js.map